import { render } from "./LocationMergeView.vue?vue&type=template&id=4a4448e8"
import script from "./LocationMergeView.vue?vue&type=script&lang=js"
export * from "./LocationMergeView.vue?vue&type=script&lang=js"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__